import React from 'react';
import './Home.css';
import profile from './assets/profile.jpeg';

const Home = () => {
  return (
    <section className="home">
      <img src={profile} alt="Jerry Liu" className="avatar" />
      <h1 className="name">Jerry Liu</h1>
      <div className="bio">
        <p className="greeting">
          Hello! <span className="wave" role="img" aria-label="wave">&#x1F44B;</span>
        </p>
        <p className="bio-text">
          I'm <strong>Jerry Liu</strong>, a Software Engineer at <strong>Meta</strong>, and I'm currently working on VR Integrity and the{' '}
          <a
            className="inline-link"
            href="https://developers.meta.com/horizon/documentation/unity/ts-odh/"
            title="Meta Quest Developer Hub"
            target="_blank"
            rel="noopener noreferrer"
          >
            Meta Quest Developer Hub
          </a>{' '}
          in <strong>Reality Labs</strong>.
        </p>
      </div>
      <div className="actions">
        <a
          className="action-link"
          href="/resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Resume
          <span className="action-arrow">&rarr;</span>
        </a>
        <a className="action-link" href="mailto:jerrliu99@gmail.com">
          Email
          <span className="action-arrow">&rarr;</span>
        </a>
        <a className="action-link" href="#portfolio">
          Portfolio
          <span className="action-arrow">&rarr;</span>
        </a>
      </div>
    </section>
  );
};

export default Home;
